import React from 'react';

const initialState = {
  step: 1,
  dealer: {
    isComplete: false,
    isEditable: true,
    error: null,
    search: null,
  },
  store: {
    isComplete: false,
    isEditable: false,
    error: null,
    search: null,
  },
  user: {
    isComplete: false,
    isEditable: false,
    error: null,
    search: null,
  },

  problem: {
    email: null,
    details: null,
    comments: null,
  },

  data: {
    dealer: null,
    store: null,
    user: null,
    order: null,
  },
};

function reducer(state, action) {
  switch (action.type) {
    case 'RESET': {
      return {
        ...initialState,
      };
    }
    case 'SET_STEP': {
      const newState = action.state || {};
      return {
        ...state,
        dealer: {
          ...state.dealer,
          ...newState.dealer,
        },
        store: {
          ...state.store,
          ...newState.store,
        },
        user: {
          ...state.user,
          ...newState.user,
        },
        problem: {
          ...state.problem,
          ...newState.problem,
        },
        step: action.step,
      };
    }
    case 'UPDATE_DEALER': {
      return {
        ...state,
        data: {
          ...state.data,
          dealer: action.dealer,
        },
      };
    }
    case 'SET_DEALER_SEARCH': {
      return {
        ...state,
        dealer: {
          ...state.dealer,
          search: action.search,
        },
      };
    }
    case 'UPDATE_STORE': {
      return {
        ...state,
        data: {
          ...state.data,
          store: action.store,
        },
      };
    }
    case 'SET_STORE_SEARCH': {
      return {
        ...state,
        store: {
          ...state.store,
          search: action.search,
        },
      };
    }
    case 'UPDATE_USER': {
      return {
        ...state,
        data: {
          ...state.data,
          user: action.user,
        },
      };
    }
    case 'SET_USER_SEARCH': {
      return {
        ...state,
        user: {
          ...state.user,
          search: action.search,
        },
      };
    }
    case 'UPDATE_ORDER': {
      return {
        ...state,
        data: {
          ...state.data,
          order: action.order,
        },
      };
    }
    case 'UPDATE_PROBLEM': {
      return {
        ...state,
        problem: action.problem,
      };
    }
    default:
      return state;
  }
}

const BoardingContext = React.createContext();
export default BoardingContext;

export function BoardingContextProvider(props) {
  const [boardingState, dispatch] = React.useReducer(reducer, initialState);

  const setStep = (step, state) => {
    dispatch({
      type: 'SET_STEP',
      step: step,
      state: state,
    });
  };

  const updateDealer = (dealer) => {
    dispatch({
      type: 'UPDATE_DEALER',
      dealer: dealer,
    });
  };

  const setDealerSearch = (search) => {
    dispatch({
      type: 'SET_DEALER_SEARCH',
      search: search,
    });
  };

  const updateStore = (store) => {
    dispatch({
      type: 'UPDATE_STORE',
      store: store,
    });
  };

  const setStoreSearch = (search) => {
    dispatch({
      type: 'SET_STORE_SEARCH',
      search: search,
    });
  };

  const updateUser = (user) => {
    dispatch({
      type: 'UPDATE_USER',
      user: user,
    });
  };

  const setUserSearch = (search) => {
    dispatch({
      type: 'SET_USER_SEARCH',
      search: search,
    });
  };

  const updateOrder = (order) => {
    dispatch({
      type: 'UPDATE_ORDER',
      order: order,
    });
  };

  const updateProblem = (problem) => {
    dispatch({
      type: 'UPDATE_PROBLEM',
      problem: problem,
    });
  };

  return (
    <BoardingContext.Provider value={{ boardingState, setStep, updateDealer, setDealerSearch, updateStore, setStoreSearch, updateUser, setUserSearch, updateOrder, updateProblem }}>
      {props.children}
    </BoardingContext.Provider>
  );
}